import TalentListPage from '../components/Talent/TalentListPage'

const Talents = () => {
  return (
    <>
      <title>Talents | Talent Service</title>
      <TalentListPage talentType="all" />
    </>
  )
}

export default Talents
